import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TokenCache } from '../../security/token-cache';
import { Subscription } from 'rxjs';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-work-orders-lists',
  templateUrl: './work-orders-lists.component.html',
  styleUrls: ['./work-orders-lists.component.css']
})
export class WorkOrdersListsComponent implements OnInit, OnDestroy {

  searchText: string;
  selectedIndex: number;
  mode: string;
  isCityUser: boolean;
  private routerSubscription: Subscription;

  constructor(
    private tokenCache: TokenCache,
    private router: Router
  ) { }

  ngOnInit() {
    this.isCityUser = this.tokenCache.checkForCityUser();
    this.syncFromUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.syncFromUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  public onTabChange(event: MatTabChangeEvent): void {
    this.navigateToTab(event.index);
  }

  private getTabs(): string[] {
    const tabs = ['myWorkOrders', 'allWorkOrders'];
    if (!this.isCityUser) {
      tabs.push('cityWorkOrders');
    }
    tabs.push('tempApprovWorkOrders');
    return tabs;
  }

  private getIndexFromKey(key: string): number {
    const tabs = this.getTabs();
    const index = key ? tabs.indexOf(key) : -1;
    return index >= 0 ? index : 0;
  }

  private getKeyFromIndex(index: number): string {
    const tabs = this.getTabs();
    return tabs[index];
  }

  private navigateToTab(index: number): void {
    const tabKey = this.getKeyFromIndex(index);
    if (!tabKey) {
      return;
    }

    const targetUrl = `/workorders/list/${tabKey}`;
    if (this.router.url !== targetUrl) {
      this.router.navigateByUrl(targetUrl);
    }
  }

  private syncFromUrl(url: string): void {
    const tabs = this.getTabs();
    const tabMatch = tabs.find((tab) => url.includes(`/workorders/list/${tab}`));
    const index = tabMatch ? tabs.indexOf(tabMatch) : 0;
    const normalizedKey = this.getKeyFromIndex(index);
    this.selectedIndex = index;

    const targetUrl = `/workorders/list/${normalizedKey}`;
    if (!url.includes('/workorders/list/') || !url.includes(targetUrl)) {
      this.router.navigateByUrl(targetUrl, { replaceUrl: true });
    }
  }
}
